import { render, staticRenderFns } from "./TickZhold.vue?vue&type=template&id=0cf107d2&"
import script from "./TickZhold.vue?vue&type=script&lang=js&"
export * from "./TickZhold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports